import React from 'react';
import FAQ from 'components/FAQ';

type TAccordion = {
  title: string;
  description: {
    description: string;
    childMarkdownRemark: {
      html: string;
    };
  };
};

export interface IFAQContainer {
  content: {
    headline: string;
    backgroundColor: string;
    slug?: string;
    listOfContentWithImages: TAccordion[];
  };
}

export const FAQContainer: React.FC<IFAQContainer> = ({ content }) => {
  if (!content) {
    return null;
  }
  const { headline, backgroundColor, slug, listOfContentWithImages } = content;

  const listOfObjects = listOfContentWithImages.map((item) => {
    return {
      title: item.title,
      description: item?.description?.description,
    };
  });

  return (
    <FAQ
      heading={headline}
      backgroundColor={backgroundColor}
      slug={slug}
      listOfObjects={listOfObjects}
    />
  );
};

export default FAQContainer;
